<template>
  <div class="flex flex-col items-center">
    <svg v-if="available" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="15" fill="#FFEEF8" stroke="#99005C" stroke-width="2" />
      <path
        d="M21.9999 16.5267C21.8951 17.6615 21.4692 18.7429 20.7721 19.6445C20.075 20.5461 19.1356 21.2305 18.0637 21.6177C16.9919 22.0049 15.8319 22.0787 14.7196 21.8307C13.6073 21.5827 12.5886 21.023 11.7828 20.2172C10.9769 19.4113 10.4172 18.3927 10.1692 17.2803C9.92118 16.168 9.99508 15.0081 10.3822 13.9362C10.7694 12.8643 11.4538 11.9249 12.3554 11.2278C13.257 10.5308 14.3385 10.1049 15.4733 10C14.8089 10.8988 14.4892 12.0063 14.5723 13.1209C14.6554 14.2356 15.1358 15.2834 15.9262 16.0737C16.7166 16.8641 17.7643 17.3445 18.879 17.4276C19.9936 17.5108 21.1011 17.1911 21.9999 16.5267Z"
        stroke="#99005C"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg v-else xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="15.5" stroke="#6E6F74" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.0547 9.67273C16.1837 9.90166 16.1662 10.185 16.01 10.3963C15.4406 11.1668 15.1665 12.116 15.2378 13.0714C15.309 14.0268 15.7208 14.9249 16.3983 15.6024C17.0757 16.2798 17.9738 16.6916 18.9292 16.7629C19.8846 16.8341 20.8339 16.5601 21.6043 15.9906C21.8156 15.8344 22.099 15.8169 22.3279 15.9459C22.5568 16.075 22.6886 16.3264 22.6644 16.5881C22.5479 17.849 22.0747 19.0506 21.3002 20.0524C20.5256 21.0541 19.4818 21.8146 18.2909 22.2448C17.0999 22.6749 15.8111 22.757 14.5752 22.4815C13.3393 22.2059 12.2074 21.584 11.312 20.6886C10.4166 19.7933 9.79475 18.6614 9.51917 17.4255C9.24359 16.1896 9.32569 14.9007 9.75588 13.7098C10.1861 12.5188 10.9465 11.475 11.9483 10.7005C12.95 9.92595 14.1517 9.45274 15.4126 9.33621C15.6742 9.31203 15.9257 9.44381 16.0547 9.67273ZM14.2115 10.9594C13.6931 11.147 13.2043 11.4147 12.7638 11.7553C11.9624 12.3749 11.3541 13.21 11.0099 14.1627C10.6658 15.1155 10.6001 16.1466 10.8205 17.1353C11.041 18.124 11.5385 19.0295 12.2548 19.7458C12.9711 20.4621 13.8766 20.9596 14.8653 21.1801C15.8541 21.4006 16.8851 21.3349 17.8379 20.9907C18.7907 20.6466 19.6257 20.0382 20.2453 19.2368C20.5859 18.7963 20.8536 18.3075 21.0412 17.7891C20.3391 18.0431 19.586 18.1489 18.8301 18.0925C17.5562 17.9975 16.3587 17.4485 15.4554 16.5452C14.5522 15.6419 14.0031 14.4445 13.9081 13.1706C13.8517 12.4146 13.9575 11.6615 14.2115 10.9594Z"
        fill="#6E6F74"
      />
    </svg>
    <div v-if="available">
      <span class="text-caption text-primary">Evening</span>
      <span class="sr-only">Available</span>
    </div>
    <div v-else>
      <span class="text-caption text-grey-text-subdued">Evening</span>
      <span class="sr-only">Unavailable</span>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'Evening',
  props: {
    available: { type: Boolean, default: false },
  },
};
</script>
